export default {

	async page_list (params) {

		const [ issues, issue_tags, users, companies, company_dbs, sites, terminals, aees ] = await Promise.all([
			Anvil.models.IssueList.fetch(),
			Anvil.models.IssueTagList.fetch(),
			Anvil.models.UserList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.c_order.AEEList.fetch()
		])

        const search = new Anvil.models.Record({
			sort_order: params.sort_order || '',
			expression: params.expression || '',

			// Additional search parameters
			closed: params.closed || null,
			responsible_user_id: params.responsible_user_id || null,
			worker_user_id: params.worker_user_id || null,
			work_tag_id: params.work_tag_id || null
		})

		await Anvil.renderPage('/issue/page_list', { issues, issue_tags, users, companies, company_dbs, sites, terminals, aees, search })
	},

	async action_refresh () {

        const [ issues, issue_tags, users, companies, company_dbs, sites, terminals, aees ] = await Promise.all([
			Anvil.models.IssueList.fetch(),
			Anvil.models.IssueTagList.fetch(),
			Anvil.models.UserList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.c_order.AEEList.fetch()
		])

		Anvil.page.issues = issues
		Anvil.page.issue_tags = issue_tags
		Anvil.page.users = users
		Anvil.page.companies = companies
		Anvil.page.company_dbs = company_dbs
		Anvil.page.sites = sites
		Anvil.page.terminals = terminals
		Anvil.page.aees = aees
		Anvil.models.components.Grid.find('#issue_grid').list = issues
	},

	async modal_edit (id, link) {

		const [ issue, issue_tags, users, companies, company_dbs, sites, terminals, aees ] = await Promise.all([
			Anvil.models.Issue.fetch(id),
			Anvil.models.IssueTagList.fetch(),
			Anvil.models.UserList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.c_order.AEEList.fetch()
		])

		// If we are creating a new issue, and there is a link, prefill the link data
		if (id === null && link) {
			for (const key of Object.keys(link)) {
				issue[key] = link[key]
			}
		}

		await Anvil.modal('/issue/modal_edit', { issue, issue_tags, users, companies, company_dbs, sites, terminals, aees })
	},

	async action_save (issue) {

		// Tell the record to commit
		await issue.record.commit()

		Anvil.toast.success('Elmentve', 'A jegy adatainak mentése sikeres')

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt munkalapot a nyilvántartásból?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('issue/action_delete', id, true)
					}
				}
			})
			return
		}

		await Anvil.models.Issue.delete(id)

		Anvil.toast.success('Törölve', 'A munkalap nyilvántartásból való törlése sikeres')

		// Refresh list
		await this.action_refresh()
	},

	async action_add_comment (comment) {

		const issue = Anvil.page.modal.issue

		// Insert comment
		await issue.record.addComment(comment)

		Anvil.toast.success('Elmentve', 'A megjegyzés mentése sikeres')

		return true
	},

	async action_edit_comment (id, comment) {

		const issue = Anvil.page.modal.issue

		// Update comment
		await issue.record.editComment(id, comment)

		Anvil.toast.success('Elmentve', 'A megjegyzés mentése sikeres')

		return true
	},

	async action_delete_comment (id) {

		const issue = Anvil.page.modal.issue

		// Delete comment
		await Anvil.REST.delete(`/issue/${issue.id}/comment/${id}`)

		// Refresh issue data (including comments)
		await issue.record.refetch()

		Anvil.toast.success('Törölve', 'A megjegyzés törlése sikeres')

		return true
	}
}